var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBookmarkStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3,1 L18,1 C18.5522847,1 19,1.44771525 19,2 L19,20 L10.5,16 L2,20 L2,2 C2,1.44771525 2.44771525,1 3,1 Z M10.5263158,11.0368421 L13.9415789,13 L13.0352632,9.3 L16.0526316,6.81052632 L12.0792105,6.48947368 L10.5263158,3 L8.97342105,6.48947368 L5,6.81052632 L8.01736842,9.3 L7.11105263,13 L10.5263158,11.0368421 Z",
  fill: "currentColor"
}))));
export default SvgBookmarkStar;